import React from 'react';
import BloodPressure from 'styles/blocks/bloodPressure';

export const LabelledInput = React.forwardRef(({
  label, helpText, children, value, onChange, onBlur, onKeyDown, onClick,
}, ref) => (
  <BloodPressure.InputContainer onKeyDown={onKeyDown} onClick={onClick}>
    <BloodPressure.Label>{label}</BloodPressure.Label>
    {children || <BloodPressure.Input ref={ref} aria-label={label} type="text" inputMode="numeric" pattern="\d*" value={value} onChange={onChange} onBlur={onBlur} />}
    {helpText && <BloodPressure.Label>{helpText}</BloodPressure.Label>}
  </BloodPressure.InputContainer>
));
